import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BulletList, BulletListItem, ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'
import { Interpolate } from '@doordash/lib-i18n'
import { HELP_URL } from '../../../../../constants'
import { CommonTextUrl } from '../../../../atoms/common-text-url'

export const IntroductionSection: React.FC<{
  image: React.ReactElement
}> = ({ image }) => {
  return (
    <SectionContainer>
      <ImageContainer>{image}</ImageContainer>

      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__online_safety_course__introduction
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__introduction__the_following_course_was_designed_to_help_you_stay_safe000
        )}
      </ContentText>
      <ContentText>
        <Interpolate
          i18n={i18n}
          i18nKey={
            i18nKeys.safetyCourse_motorcycle_step1__introduction__if_you_have_any_questions_about_safety_on_the_doordash001
          }
          components={[<CommonTextUrl url={HELP_URL} />]}
        />
      </ContentText>

      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__introduction__food_safety
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__the_things_you_do_as_a_dasher_can_have_a
        )}
      </ContentText>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__food_contamination
        )}
      </Text>
      <BulletList>
        {[
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__keep_your_vehicle_and_equipment_eg_bags_clean_and_wellmaintained,
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__check_that_each_order_is_packaged_and_sealed_properly_report,
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__do_not_open_or_tamper_with_a_customer_order,
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__wash_your_hands_regularly_and_continue_to_use_hand_sanitiser,
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__avoid_coughing_spitting_sneezing_or_smoking_while_transporting_food,
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__if_you_feel_unwell_for_your_own_safety_and_to,
        ].map((key, i) => (
          <BulletListItem mb={'XSmall'} key={i}>
            <ContentText>{i18n.t(key)}</ContentText>
          </BulletListItem>
        ))}
      </BulletList>

      <Text styles={Text.Styles.Body2} weight={Text.Weights.Bold}>
        {i18n.t(
          i18nKeys.safetyCourse_motorcycle_step1__food_safety__time_and_temperature
        )}
      </Text>
      <BulletList>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            {i18n.t(
              i18nKeys.safetyCourse_motorcycle_step1__food_safety__use_a_thermally_insulated_bag_for_deliveries_you_can_get
            )}
          </ContentText>
        </BulletListItem>
        <BulletListItem mb={'XSmall'}>
          <ContentText>
            <Interpolate
              i18n={i18n}
              i18nKey={
                i18nKeys.safetyCourse_motorcycle_step1__food_safety__if_you_experience_a_significant_delay_after_picking_up_an
              }
              components={[<CommonTextUrl url={HELP_URL} />]}
            />
          </ContentText>
        </BulletListItem>
      </BulletList>
    </SectionContainer>
  )
}
